import { useEffect, useRef } from "react";
import modalStyle from "../modal.module.css";

export interface ConfirmModalData {
  text: string;
  confirm: () => void | Promise<void>;
  close: () => void;
}

function ConfirmModal({ text, confirm, close }: Readonly<ConfirmModalData>) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const confirmRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const dialog = dialogRef?.current;
    if (dialog) {
      dialog.showModal();
      dialog.addEventListener("close", close);
    }
    confirmRef.current?.focus();

    return () => {
      if (dialog) {
        dialog.removeEventListener("close", close);
      }
    };
  }, [close]);

  return (
    <dialog ref={dialogRef} className={modalStyle.dialog + " " + modalStyle.modalStyle}>
      <h3>Confirmation</h3>
      <p className={modalStyle.descriptionText}>{text}</p>

      <div className={modalStyle.buttonRow}>
        <button className={modalStyle.cancelButton} onClick={close}>
          Cancel
        </button>
        <button
          className={modalStyle.confirmButton}
          ref={confirmRef}
          onClick={() => {
            confirm();
            close();
          }}
        >
          Confirm
        </button>
      </div>
    </dialog>
  );
}

export default ConfirmModal;
